export default __webpack_public_path__ + "static/media/Wave.4d81e3ce.svg";